// Original source: ./src/cql/OMTKData.cql
// More information: https://www.fhir.org/guides/cdc/opioid-mme-r4/Library-OMTKData.html
const OMTKData = {
  DrugIngredients: [
    {
      drugCode: 197696,
      drugName: "72 HR Fentanyl 0.075 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.075 MG/HR",
      strengthValue: 0.075,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 197873,
      drugName: "Levorphanol 2 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6378,
      ingredientName: "Levorphanol",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 205533,
      drugName: "1 ML Buprenorphine 0.3 MG/ML Injection [Buprenex]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.3 MG/ML",
      strengthValue: 0.3,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 238129,
      drugName: "1 ML Buprenorphine 0.3 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.3 MG/ML",
      strengthValue: 0.3,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 238133,
      drugName: "Pentazocine 30 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 8001,
      ingredientName: "Pentazocine",
      strength: "30 MG/ML",
      strengthValue: 30.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 245134,
      drugName: "72 HR Fentanyl 0.025 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.025 MG/HR",
      strengthValue: 0.025,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 245135,
      drugName: "72 HR Fentanyl 0.05 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/HR",
      strengthValue: 0.05,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 245136,
      drugName: "72 HR Fentanyl 0.1 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/HR",
      strengthValue: 0.1,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 261106,
      drugName: "Fentanyl 0.2 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 261107,
      drugName: "Fentanyl 0.6 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 261108,
      drugName: "Fentanyl 0.8 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 261109,
      drugName: "Fentanyl 1.2 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "1.2 MG",
      strengthValue: 1.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 261110,
      drugName: "Fentanyl 1.6 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "1.6 MG",
      strengthValue: 1.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 261184,
      drugName: "72 HR Fentanyl 0.025 MG/HR Transdermal System [Duragesic]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.025 MG/HR",
      strengthValue: 0.025,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 261185,
      drugName: "72 HR Fentanyl 0.05 MG/HR Transdermal System [Duragesic]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/HR",
      strengthValue: 0.05,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 261186,
      drugName: "72 HR Fentanyl 0.075 MG/HR Transdermal System [Duragesic]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.075 MG/HR",
      strengthValue: 0.075,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 262071,
      drugName: "72 HR Fentanyl 0.1 MG/HR Transdermal System [Duragesic]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/HR",
      strengthValue: 0.1,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 262219,
      drugName: "Fentanyl 0.4 MG Oral Lozenge [Actiq]",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 310293,
      drugName: "Fentanyl 1.2 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "1.2 MG",
      strengthValue: 1.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 310294,
      drugName: "Fentanyl 1.6 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "1.6 MG",
      strengthValue: 1.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 310295,
      drugName: "Fentanyl 0.2 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 310297,
      drugName: "Fentanyl 0.4 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 312104,
      drugName: "Belladonna Alkaloids 16.2 MG / Opium 30 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7676,
      ingredientName: "Opium",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 312107,
      drugName: "Belladonna Alkaloids 16.2 MG / Opium 60 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7676,
      ingredientName: "Opium",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 312289,
      drugName: "Naloxone 0.5 MG / Pentazocine 50 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 8001,
      ingredientName: "Pentazocine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 313992,
      drugName: "Fentanyl 0.6 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 313993,
      drugName: "Fentanyl 0.8 MG Oral Lozenge",
      doseFormCode: 316992,
      doseFormName: "Oral Lozenge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 351264,
      drugName: "Buprenorphine 2 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 351265,
      drugName: "Buprenorphine 8 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 351266,
      drugName: "Buprenorphine 2 MG / Naloxone 0.5 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 351267,
      drugName: "Buprenorphine 8 MG / Naloxone 2 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 577057,
      drugName: "72 HR Fentanyl 0.012 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.012 MG/HR",
      strengthValue: 0.012,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 583490,
      drugName: "72 HR Fentanyl 0.012 MG/HR Transdermal System [Duragesic]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.012 MG/HR",
      strengthValue: 0.012,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 637540,
      drugName:
        "Aspirin 325 MG / Oxycodone Hydrochloride 4.5 MG / oxycodone terephthalate 0.38 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "4.5 MG",
      strengthValue: 4.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 637540,
      drugName:
        "Aspirin 325 MG / Oxycodone Hydrochloride 4.5 MG / oxycodone terephthalate 0.38 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "0.38 MG",
      strengthValue: 0.38,
      strengthUnit: "MG",
    },
    {
      drugCode: 668363,
      drugName: "Fentanyl 0.1 MG Buccal Tablet",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG",
      strengthValue: 0.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 668364,
      drugName: "Fentanyl 0.2 MG Buccal Tablet",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 668365,
      drugName: "Fentanyl 0.4 MG Buccal Tablet",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 668366,
      drugName: "Fentanyl 0.6 MG Buccal Tablet",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 668367,
      drugName: "Fentanyl 0.8 MG Buccal Tablet",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 668622,
      drugName: "Fentanyl 0.1 MG Buccal Tablet [Fentora]",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG",
      strengthValue: 0.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 668624,
      drugName: "Fentanyl 0.2 MG Buccal Tablet [Fentora]",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 668626,
      drugName: "Fentanyl 0.4 MG Buccal Tablet [Fentora]",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 668628,
      drugName: "Fentanyl 0.6 MG Buccal Tablet [Fentora]",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 668630,
      drugName: "Fentanyl 0.8 MG Buccal Tablet [Fentora]",
      doseFormCode: 970789,
      doseFormName: "Buccal Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 727759,
      drugName: "2 ML Fentanyl 0.05 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 825409,
      drugName: "tapentadol 100 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 825411,
      drugName: "tapentadol 50 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 825413,
      drugName: "tapentadol 75 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "75 MG",
      strengthValue: 75.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 830196,
      drugName: "opium tincture 100 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7676,
      ingredientName: "Opium",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 833709,
      drugName:
        "24 HR tramadol hydrochloride 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 833711,
      drugName:
        "24 HR tramadol hydrochloride 200 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 833713,
      drugName:
        "24 HR tramadol hydrochloride 300 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "300 MG",
      strengthValue: 300.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 835603,
      drugName: "tramadol hydrochloride 50 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 835605,
      drugName: "tramadol hydrochloride 50 MG Oral Tablet [Ultram]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 836395,
      drugName:
        "Acetaminophen 325 MG / tramadol hydrochloride 37.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "37.5 MG",
      strengthValue: 37.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 836397,
      drugName:
        "Acetaminophen 325 MG / tramadol hydrochloride 37.5 MG Oral Tablet [Ultracet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "37.5 MG",
      strengthValue: 37.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 845315,
      drugName:
        "24 HR tramadol hydrochloride 200 MG Extended Release Oral Tablet [Ultram]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 848768,
      drugName: "Aspirin 325 MG / Oxycodone Hydrochloride 4.84 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "4.84 MG",
      strengthValue: 4.84,
      strengthUnit: "MG",
    },
    {
      drugCode: 848772,
      drugName:
        "Aspirin 325 MG / Oxycodone Hydrochloride 4.84 MG Oral Tablet [Percodan Reformulated May 2009]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "4.84 MG",
      strengthValue: 4.84,
      strengthUnit: "MG",
    },
    {
      drugCode: 848928,
      drugName:
        "Aspirin 325 MG / Oxycodone Hydrochloride 4.84 MG Oral Tablet [Endodan Reformulated May 2009]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "4.84 MG",
      strengthValue: 4.84,
      strengthUnit: "MG",
    },
    {
      drugCode: 854140,
      drugName: "tapentadol 100 MG Oral Tablet [Nucynta]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 854142,
      drugName: "tapentadol 50 MG Oral Tablet [Nucynta]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 854144,
      drugName: "tapentadol 75 MG Oral Tablet [Nucynta]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "75 MG",
      strengthValue: 75.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 856940,
      drugName:
        "Acetaminophen 21.7 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 856942,
      drugName:
        "Acetaminophen 21.7 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution [Hycet]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 856944,
      drugName:
        "Acetaminophen 21.7 MG/ML / Hydrocodone Bitartrate 0.67 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.67 MG/ML",
      strengthValue: 0.67,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 856946,
      drugName:
        "Acetaminophen 21.7 MG/ML / Hydrocodone Bitartrate 0.67 MG/ML Oral Solution [Zamicet]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.67 MG/ML",
      strengthValue: 0.67,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 856980,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 856987,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 856992,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 856999,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857001,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 10 MG Oral Tablet [Norco]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857002,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857004,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 5 MG Oral Tablet [Norco]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857005,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 857007,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet [Norco]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 857099,
      drugName:
        "Acetaminophen 33.3 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 857131,
      drugName:
        "Acetaminophen 400 MG / Hydrocodone Bitartrate 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857237,
      drugName: "Pentazocine 30 MG/ML Injectable Solution [Talwin]",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 8001,
      ingredientName: "Pentazocine",
      strength: "30 MG/ML",
      strengthValue: 30.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 857391,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 2.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 857510,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 4 MG / HYDROCODONE POLISTIREX 5 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 857512,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 8 MG / HYDROCODONE POLISTIREX 10 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 858770,
      drugName: "Hydrocodone Bitartrate 2.5 MG / Ibuprofen 200 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 858772,
      drugName:
        "Hydrocodone Bitartrate 2.5 MG / Ibuprofen 200 MG Oral Tablet [Reprexain]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 858778,
      drugName: "Hydrocodone Bitartrate 5 MG / Ibuprofen 200 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 858780,
      drugName:
        "Hydrocodone Bitartrate 5 MG / Ibuprofen 200 MG Oral Tablet [Ibudone]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 858784,
      drugName:
        "Hydrocodone Bitartrate 5 MG / Ibuprofen 200 MG Oral Tablet [Reprexain]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 858798,
      drugName: "Hydrocodone Bitartrate 7.5 MG / Ibuprofen 200 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 858838,
      drugName:
        "Hydrocodone Bitartrate 7.5 MG / Ibuprofen 200 MG Oral Tablet [Vicoprofen]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 859315,
      drugName: "Hydrocodone Bitartrate 10 MG / Ibuprofen 200 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 859317,
      drugName:
        "Hydrocodone Bitartrate 10 MG / Ibuprofen 200 MG Oral Tablet [Ibudone]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 859383,
      drugName:
        "Guaifenesin 40 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 860792,
      drugName: "1 ML Meperidine Hydrochloride 75 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "75 MG/ML",
      strengthValue: 75.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861447,
      drugName: "Meperidine Hydrochloride 10 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861455,
      drugName: "Meperidine Hydrochloride 100 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 861459,
      drugName: "Meperidine Hydrochloride 100 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861463,
      drugName: "Meperidine Hydrochloride 50 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861467,
      drugName: "Meperidine Hydrochloride 50 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 861473,
      drugName: "1 ML Meperidine Hydrochloride 50 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861476,
      drugName: "1 ML Meperidine Hydrochloride 25 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861479,
      drugName: "Meperidine Hydrochloride 10 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861493,
      drugName: "1 ML Meperidine Hydrochloride 100 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2539196,
      drugName:
        "1 ML meperidine hydrochloride 100 MG/ML Prefilled Syringe [Demerol]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2539192,
      drugName:
        "1 ML meperidine hydrochloride 25 MG/ML Prefilled Syringe [Demerol]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2539188,
      drugName:
        "1 ML meperidine hydrochloride 50 MG/ML Prefilled Syringe [Demerol]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2539200,
      drugName:
        "1 ML meperidine hydrochloride 75 MG/ML Prefilled Syringe [Demerol]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "75 MG/ML",
      strengthValue: 75.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861494,
      drugName: "1 ML Meperidine Hydrochloride 25 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861517,
      drugName: "Meperidine Hydrochloride 100 MG Oral Tablet [Demerol]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 861520,
      drugName:
        "Meperidine Hydrochloride 100 MG/ML Injectable Solution [Demerol]",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861522,
      drugName:
        "Meperidine Hydrochloride 50 MG/ML Injectable Solution [Demerol]",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861525,
      drugName: "Meperidine Hydrochloride 50 MG Oral Tablet [Demerol]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 861529,
      drugName: "1 ML Meperidine Hydrochloride 50 MG/ML Cartridge [Demerol]",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 861578,
      drugName:
        "Meperidine Hydrochloride 50 MG / Promethazine Hydrochloride 25 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 861617,
      drugName: "1 ML Meperidine Hydrochloride 75 MG/ML Cartridge [Demerol]",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "75 MG/ML",
      strengthValue: 75.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 863845,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 100 MG / Naltrexone hydrochloride 4 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863847,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 100 MG / Naltrexone hydrochloride 4 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863848,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 20 MG / Naltrexone hydrochloride 0.8 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863849,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 20 MG / Naltrexone hydrochloride 0.8 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863850,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 30 MG / Naltrexone hydrochloride 1.2 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863851,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 30 MG / Naltrexone hydrochloride 1.2 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863852,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 50 MG / Naltrexone hydrochloride 2 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863853,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 50 MG / Naltrexone hydrochloride 2 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863854,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 60 MG / Naltrexone hydrochloride 2.4 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863855,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 60 MG / Naltrexone hydrochloride 2.4 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863856,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 80 MG / Naltrexone hydrochloride 3.2 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 863857,
      drugName:
        "Abuse-Deterrent Morphine Sulfate 80 MG / Naltrexone hydrochloride 3.2 MG Extended Release Oral Capsule [Embeda]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864706,
      drugName: "Methadone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864708,
      drugName: "Methadone Hydrochloride 10 MG Oral Tablet [Dolophine]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864712,
      drugName: "Methadone Hydrochloride 10 MG Oral Tablet [Methadose]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864714,
      drugName: "Methadone Hydrochloride 10 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 864718,
      drugName: "Methadone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864720,
      drugName: "Methadone Hydrochloride 5 MG Oral Tablet [Dolophine]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864737,
      drugName: "Methadone Hydrochloride 5 MG Oral Tablet [Methadose]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864761,
      drugName: "Methadone Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 864769,
      drugName: "Methadone Hydrochloride 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 864978,
      drugName: "Methadone Hydrochloride 40 MG Tablet for Oral Suspension",
      doseFormCode: 1861409,
      doseFormName: "Tablet for Oral Suspension",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 864980,
      drugName:
        "Methadone Hydrochloride 40 MG Tablet for Oral Suspension [Methadose]",
      doseFormCode: 1861409,
      doseFormName: "Tablet for Oral Suspension",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1302739,
      drugName: "Butorphanol 10 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 886622,
      drugName: "Butorphanol Tartrate 2 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 886627,
      drugName: "1 ML Butorphanol Tartrate 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 886634,
      drugName: "Butorphanol Tartrate 1 MG/ACTUAT Metered Dose Nasal Spray",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "1 MG/ACTUAT",
      strengthValue: 1.0,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 891874,
      drugName: "Morphine Sulfate 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891878,
      drugName: "12 HR Morphine Sulfate 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891881,
      drugName: "Morphine Sulfate 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891883,
      drugName: "12 HR Morphine Sulfate 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891885,
      drugName: "12 HR Morphine Sulfate 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891888,
      drugName: "Morphine Sulfate 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891890,
      drugName: "12 HR Morphine Sulfate 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 891893,
      drugName: "Morphine Sulfate 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892297,
      drugName: "24 HR Morphine Sulfate 120 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "120 MG",
      strengthValue: 120.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892299,
      drugName:
        "24 HR Morphine Sulfate 120 MG Extended Release Oral Capsule [Avinza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "120 MG",
      strengthValue: 120.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892342,
      drugName: "24 HR Morphine Sulfate 30 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892344,
      drugName:
        "24 HR Morphine Sulfate 30 MG Extended Release Oral Capsule [Avinza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892345,
      drugName: "Morphine Sulfate 30 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892349,
      drugName: "24 HR Morphine Sulfate 60 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892351,
      drugName:
        "24 HR Morphine Sulfate 60 MG Extended Release Oral Capsule [Avinza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892352,
      drugName: "Morphine Sulfate 60 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892355,
      drugName: "24 HR Morphine Sulfate 90 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "90 MG",
      strengthValue: 90.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892357,
      drugName:
        "24 HR Morphine Sulfate 90 MG Extended Release Oral Capsule [Avinza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "90 MG",
      strengthValue: 90.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892473,
      drugName: "10 ML Morphine Sulfate 0.5 MG/ML Injection [Duramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 892489,
      drugName: "10 ML Morphine Sulfate 1 MG/ML Injection [Duramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 892494,
      drugName: "Morphine Sulfate 10 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892496,
      drugName: "Morphine Sulfate 10 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892516,
      drugName: "Morphine Sulfate 10 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892554,
      drugName: "Morphine Sulfate 100 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892556,
      drugName:
        "Morphine Sulfate 100 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892560,
      drugName:
        "Morphine Sulfate 100 MG Extended Release Oral Tablet [MS Contin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892574,
      drugName:
        "Morphine Sulfate 15 MG Extended Release Oral Tablet [MS Contin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892582,
      drugName: "Morphine Sulfate 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892589,
      drugName: "Morphine Sulfate 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 892596,
      drugName: "Morphine Sulfate 20 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892598,
      drugName: "Morphine Sulfate 20 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892603,
      drugName: "Morphine Sulfate 20 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892625,
      drugName: "Morphine Sulfate 20 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG/ML",
      strengthValue: 20.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 892643,
      drugName: "Morphine Sulfate 200 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892645,
      drugName:
        "Morphine Sulfate 200 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892646,
      drugName: "Morphine Sulfate 200 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892648,
      drugName:
        "Morphine Sulfate 200 MG Extended Release Oral Tablet [MS Contin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892652,
      drugName: "20 ML Morphine Sulfate 25 MG/ML Injection [Infumorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 892658,
      drugName: "Morphine Sulfate 30 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892660,
      drugName:
        "Morphine Sulfate 30 MG Extended Release Oral Tablet [MS Contin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892672,
      drugName: "Morphine Sulfate 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 892678,
      drugName: "Morphine Sulfate 30 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894780,
      drugName: "Morphine Sulfate 4 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 894801,
      drugName: "Morphine Sulfate 50 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894803,
      drugName: "Morphine Sulfate 50 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894805,
      drugName: "Morphine Sulfate 60 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894807,
      drugName: "Morphine Sulfate 5 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894813,
      drugName:
        "Morphine Sulfate 60 MG Extended Release Oral Tablet [MS Contin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894814,
      drugName: "Morphine Sulfate 80 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894816,
      drugName: "Morphine Sulfate 80 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894911,
      drugName: "0.7 ML Morphine Sulfate 14.3 MG/ML Auto-Injector",
      doseFormCode: 1649570,
      doseFormName: "Auto-Injector",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "14.3 MG/ML",
      strengthValue: 14.3,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 894912,
      drugName: "1 ML Morphine Sulfate 10 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 894914,
      drugName: "1 ML Morphine Sulfate 8 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "8 MG/ML",
      strengthValue: 8.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 894918,
      drugName: "12 HR Morphine Sulfate 200 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894942,
      drugName: "24 HR Morphine Sulfate 45 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "45 MG",
      strengthValue: 45.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 894970,
      drugName: "24 HR Morphine Sulfate 75 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "75 MG",
      strengthValue: 75.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 895201,
      drugName: "Morphine Sulfate 20 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 895217,
      drugName: "Morphine Sulfate 5 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 895221,
      drugName: "Morphine Sulfate 50 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 895861,
      drugName: "Morphine Sulfate 25 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG",
      strengthValue: 25.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 895869,
      drugName: "Morphine Sulfate 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897653,
      drugName: "1 ML Hydromorphone Hydrochloride 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897657,
      drugName: "Hydromorphone Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897658,
      drugName: "Hydromorphone Hydrochloride 1 MG/ML Oral Solution [Dilaudid]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897696,
      drugName: "Hydromorphone Hydrochloride 2 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897698,
      drugName: "Hydromorphone Hydrochloride 2 MG Oral Tablet [Dilaudid]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897702,
      drugName: "Hydromorphone Hydrochloride 4 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG",
      strengthValue: 4.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897704,
      drugName: "Hydromorphone Hydrochloride 4 MG Oral Tablet [Dilaudid]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG",
      strengthValue: 4.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897710,
      drugName: "Hydromorphone Hydrochloride 8 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897712,
      drugName: "Hydromorphone Hydrochloride 8 MG Oral Tablet [Dilaudid]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897745,
      drugName: "Hydromorphone Hydrochloride 2 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897749,
      drugName: "Hydromorphone Hydrochloride 3 MG Rectal Suppository",
      doseFormCode: 316978,
      doseFormName: "Rectal Suppository",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "3 MG",
      strengthValue: 3.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 897753,
      drugName: "1 ML Hydromorphone Hydrochloride 4 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897756,
      drugName: "1 ML Hydromorphone Hydrochloride 1 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897757,
      drugName: "1 ML Hydromorphone Hydrochloride 2 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 897758,
      drugName: "1 ML Hydromorphone Hydrochloride 4 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 898612,
      drugName:
        "12 HR Hydromorphone Hydrochloride 3 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "3 MG",
      strengthValue: 3.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 898624,
      drugName:
        "Hydromorphone Hydrochloride 30 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902729,
      drugName:
        "24 HR Hydromorphone Hydrochloride 12 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "12 MG",
      strengthValue: 12.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902733,
      drugName:
        "24 HR Hydromorphone Hydrochloride 12 MG Extended Release Oral Tablet [Exalgo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "12 MG",
      strengthValue: 12.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902736,
      drugName:
        "24 HR Hydromorphone Hydrochloride 16 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902738,
      drugName:
        "24 HR Hydromorphone Hydrochloride 16 MG Extended Release Oral Tablet [Exalgo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902741,
      drugName:
        "24 HR Hydromorphone Hydrochloride 8 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 902743,
      drugName:
        "24 HR Hydromorphone Hydrochloride 8 MG Extended Release Oral Tablet [Exalgo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 904415,
      drugName: "Nalbuphine Hydrochloride 10 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 7238,
      ingredientName: "Nalbuphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 904440,
      drugName: "Nalbuphine Hydrochloride 20 MG/ML Injectable Solution",
      doseFormCode: 316949,
      doseFormName: "Injectable Solution",
      ingredientCode: 7238,
      ingredientName: "Nalbuphine",
      strength: "20 MG/ML",
      strengthValue: 20.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 904870,
      drugName: "168 HR Buprenorphine 0.01 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.01 MG/HR",
      strengthValue: 0.01,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 904874,
      drugName: "168 HR Buprenorphine 0.01 MG/HR Transdermal System [BuTrans]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.01 MG/HR",
      strengthValue: 0.01,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 904876,
      drugName: "168 HR Buprenorphine 0.02 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.02 MG/HR",
      strengthValue: 0.02,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 904878,
      drugName: "168 HR Buprenorphine 0.02 MG/HR Transdermal System [BuTrans]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.02 MG/HR",
      strengthValue: 0.02,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 904880,
      drugName: "168 HR Buprenorphine 0.005 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.005 MG/HR",
      strengthValue: 0.005,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 904882,
      drugName: "168 HR Buprenorphine 0.005 MG/HR Transdermal System [BuTrans]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.005 MG/HR",
      strengthValue: 0.005,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 977874,
      drugName:
        "12 HR Oxymorphone Hydrochloride 10 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977876,
      drugName:
        "12 HR Oxymorphone Hydrochloride 10 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977894,
      drugName:
        "12 HR Oxymorphone Hydrochloride 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977896,
      drugName:
        "12 HR Oxymorphone Hydrochloride 15 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977902,
      drugName:
        "12 HR Oxymorphone Hydrochloride 20 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977904,
      drugName:
        "12 HR Oxymorphone Hydrochloride 20 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977909,
      drugName:
        "12 HR Oxymorphone Hydrochloride 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977911,
      drugName:
        "12 HR Oxymorphone Hydrochloride 30 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977915,
      drugName:
        "12 HR Oxymorphone Hydrochloride 40 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977917,
      drugName:
        "12 HR Oxymorphone Hydrochloride 40 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977923,
      drugName:
        "12 HR Oxymorphone Hydrochloride 5 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977925,
      drugName:
        "12 HR Oxymorphone Hydrochloride 5 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977929,
      drugName:
        "12 HR Oxymorphone Hydrochloride 7.5 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 977931,
      drugName:
        "12 HR Oxymorphone Hydrochloride 7.5 MG Extended Release Oral Tablet [Opana]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 977935,
      drugName: "1 ML Oxymorphone Hydrochloride 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 977937,
      drugName: "1 ML Oxymorphone Hydrochloride 1 MG/ML Injection [Opana]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 977939,
      drugName: "Oxymorphone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977940,
      drugName: "Oxymorphone Hydrochloride 5 MG Oral Tablet [Opana]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977942,
      drugName: "Oxymorphone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 977943,
      drugName: "Oxymorphone Hydrochloride 10 MG Oral Tablet [Opana]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7814,
      ingredientName: "Oxymorphone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 991147,
      drugName: "Methadone Hydrochloride 10 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 991149,
      drugName: "Methadone Hydrochloride 10 MG/ML Oral Solution [Methadose]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 991486,
      drugName:
        "Codeine Phosphate 2 MG/ML / Promethazine Hydrochloride 1.25 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 992656,
      drugName:
        "homatropine methylbromide 1.5 MG / Hydrocodone Bitartrate 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 992668,
      drugName:
        "homatropine methylbromide 0.3 MG/ML / Hydrocodone Bitartrate 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 992671,
      drugName:
        "homatropine methylbromide 0.3 MG/ML / Hydrocodone Bitartrate 1 MG/ML Oral Solution [Hycodan]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 992675,
      drugName:
        "homatropine methylbromide 0.3 MG/ML / Hydrocodone Bitartrate 1 MG/ML Oral Solution [Hydromet]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 992733,
      drugName:
        "homatropine methylbromide 1.5 MG / Hydrocodone Bitartrate 5 MG Oral Tablet [Tussigon]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 993755,
      drugName:
        "Acetaminophen 24 MG/ML / Codeine Phosphate 2.4 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2.4 MG/ML",
      strengthValue: 2.4,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 993763,
      drugName:
        "Acetaminophen 24 MG/ML / Codeine Phosphate 2.4 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2.4 MG/ML",
      strengthValue: 2.4,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 993767,
      drugName:
        "Acetaminophen 24 MG/ML / Codeine Phosphate 2.4 MG/ML Oral Suspension [Capital and Codeine]",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2.4 MG/ML",
      strengthValue: 2.4,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 993770,
      drugName: "Acetaminophen 300 MG / Codeine Phosphate 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 993781,
      drugName: "Acetaminophen 300 MG / Codeine Phosphate 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 993837,
      drugName:
        "Acetaminophen 300 MG / Codeine Phosphate 30 MG Oral Tablet [Tylenol with Codeine]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 993890,
      drugName: "Acetaminophen 300 MG / Codeine Phosphate 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 993892,
      drugName:
        "Acetaminophen 300 MG / Codeine Phosphate 60 MG Oral Tablet [Tylenol with Codeine]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2118728,
      drugName: "Acetaminophen 325 MG / Benzhydrocodone 4.08 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "4.08 MG",
      strengthValue: 4.08,
      strengthUnit: "MG",
    },
    {
      drugCode: 2118730,
      drugName:
        "Acetaminophen 325 MG / Benzhydrocodone 4.08 MG Oral Tablet [Apadaz]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "4.08 MG",
      strengthValue: 4.08,
      strengthUnit: "MG",
    },
    {
      drugCode: 2001364,
      drugName:
        "Acetaminophen 325 MG / Benzhydrocodone 6.12 MG Oral Tablet [Apadaz]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "6.12 MG",
      strengthValue: 6.12,
      strengthUnit: "MG",
    },
    {
      drugCode: 2118732,
      drugName: "Acetaminophen 325 MG / Benzhydrocodone 8.16 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "8.16 MG",
      strengthValue: 8.16,
      strengthUnit: "MG",
    },
    {
      drugCode: 2118734,
      drugName:
        "Acetaminophen 325 MG / Benzhydrocodone 8.16 MG Oral Tablet [Apadaz]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "8.16 MG",
      strengthValue: 8.16,
      strengthUnit: "MG",
    },
    {
      drugCode: 993943,
      drugName:
        "Acetaminophen 325 MG / Butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2001352,
      ingredientName: "Benzhydrocodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 994226,
      drugName:
        "Aspirin 325 MG / Carisoprodol 200 MG / Codeine Phosphate 16 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 994237,
      drugName:
        "Aspirin 325 MG / butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 994239,
      drugName:
        "Aspirin 325 MG / butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule [Ascomp]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 994277,
      drugName:
        "Aspirin 325 MG / butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule [Fiorinal with Codeine]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 994289,
      drugName:
        "Brompheniramine Maleate 0.27 MG/ML / Codeine Phosphate 1.27 MG/ML / Pseudoephedrine Hydrochloride 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.27 MG/ML",
      strengthValue: 1.27,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 994402,
      drugName:
        "Brompheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1.5 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.5 MG/ML",
      strengthValue: 1.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995041,
      drugName:
        "Chlorpheniramine Maleate 0.2 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 3 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995065,
      drugName:
        "Chlorpheniramine Maleate 0.222 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 3.33 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995068,
      drugName:
        "Chlorpheniramine Maleate 0.222 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995071,
      drugName:
        "Chlorpheniramine Maleate 0.25 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995075,
      drugName:
        "Chlorpheniramine Maleate 0.25 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 0.375 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995079,
      drugName:
        "Chlorpheniramine Maleate 0.266 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 4 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995082,
      drugName:
        "Chlorpheniramine Maleate 0.267 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995086,
      drugName:
        "Chlorpheniramine Maleate 0.286 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 4.29 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995093,
      drugName:
        "Chlorpheniramine Maleate 0.286 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995108,
      drugName:
        "Chlorpheniramine Maleate 0.333 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 5 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995116,
      drugName:
        "Chlorpheniramine Maleate 0.333 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995120,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995123,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1 MG/ML Oral Suspension",
      doseFormCode: 316969,
      doseFormName: "Oral Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995128,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1.8 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995132,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1.8 MG/ML Oral Solution [Z Tuss AC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995226,
      drugName:
        "Codeine Phosphate 0.5 MG/ML / Guaifenesin 15 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995438,
      drugName:
        "Codeine Phosphate 1.26 MG/ML / Guaifenesin 20 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.26 MG/ML",
      strengthValue: 1.26,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995440,
      drugName:
        "Codeine Phosphate 1.26 MG/ML / Guaifenesin 20 MG/ML Oral Solution [M-Clear WC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.26 MG/ML",
      strengthValue: 1.26,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995441,
      drugName:
        "Codeine Phosphate 1.5 MG/ML / Guaifenesin 45 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.5 MG/ML",
      strengthValue: 1.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995443,
      drugName:
        "Codeine Phosphate 1.5 MG/ML / Guaifenesin 45 MG/ML Oral Solution [Mar-cof CG]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.5 MG/ML",
      strengthValue: 1.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995447,
      drugName:
        "Codeine Phosphate 1.8 MG/ML / Pyrilamine Maleate 1.67 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995450,
      drugName: "Codeine Phosphate 10 MG / Guaifenesin 300 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 995476,
      drugName: "Codeine Phosphate 10 MG / Guaifenesin 400 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 995478,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG Oral Tablet [Allfen CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 995483,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 40 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995868,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995872,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML Oral Solution [Cheratussin]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995936,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 300 MG Oral Tablet [Brontex]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 995940,
      drugName:
        "Codeine Phosphate 0.5 MG/ML / Guaifenesin 15 MG/ML Oral Solution [Brontex]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995956,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML Oral Solution [Cheracol with Codeine]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995983,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995985,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Biotussin]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 995993,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Cheratussin DAC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996462,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML Oral Solution [Guiatuss AC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996484,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML Oral Solution [Robafen AC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996580,
      drugName:
        "Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 1 MG/ML / Pyrilamine Maleate 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996584,
      drugName:
        "Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 1 MG/ML / Pyrilamine Maleate 1 MG/ML Oral Solution [Zotex C]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996640,
      drugName:
        "Codeine Phosphate 2 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML / Triprolidine Hydrochloride 0.25 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996648,
      drugName:
        "Codeine Phosphate 2 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML / Triprolidine Hydrochloride 0.25 MG/ML Oral Solution [Pseudodine C]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996655,
      drugName:
        "Codeine Phosphate 2 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996706,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996708,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet [Maxiphen CDX]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996710,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 20 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996712,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 20 MG Oral Tablet [Ambifed-G CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996714,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996716,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 30 MG Oral Tablet [Ambifed CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996718,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 40 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996720,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 40 MG Oral Tablet [Maxifed-G CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996722,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996724,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet [Maxifed CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996725,
      drugName: "Codeine Phosphate 20 MG / Guaifenesin 400 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996727,
      drugName:
        "Codeine Phosphate 20 MG / Guaifenesin 400 MG Oral Tablet [Allfen CDX]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996728,
      drugName:
        "Codeine Phosphate 20 MG / Pseudoephedrine Hydrochloride 60 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996730,
      drugName:
        "Codeine Phosphate 20 MG / Pseudoephedrine Hydrochloride 60 MG Oral Capsule [Nucofed]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996736,
      drugName: "Codeine Phosphate 9 MG / Guaifenesin 200 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "9 MG",
      strengthValue: 9.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996738,
      drugName:
        "Codeine Phosphate 9 MG / Guaifenesin 200 MG Oral Capsule [M-Clear WC]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "9 MG",
      strengthValue: 9.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996757,
      drugName:
        "Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 1 MG/ML / Promethazine Hydrochloride 1.25 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 996988,
      drugName: "Aspirin 300 MG / Codeine Phosphate 8 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 996998,
      drugName:
        "Brompheniramine Maleate 0.266 MG/ML / Codeine Phosphate 1.27 MG/ML / Phenylephrine Hydrochloride 0.666 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.27 MG/ML",
      strengthValue: 1.27,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 997169,
      drugName: "Codeine Phosphate 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 997170,
      drugName: "Codeine sulfate 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 997287,
      drugName: "Codeine sulfate 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 997296,
      drugName: "Codeine sulfate 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 997398,
      drugName: "Codeine Phosphate 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 998212,
      drugName: "1 ML Morphine Sulfate 2 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 998213,
      drugName: "1 ML Morphine Sulfate 4 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 999729,
      drugName:
        "Acetaminophen 250 MG / tramadol hydrochloride 50 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1010600,
      drugName: "Buprenorphine 2 MG / Naloxone 0.5 MG Sublingual Film",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1010603,
      drugName:
        "Buprenorphine 2 MG / Naloxone 0.5 MG Sublingual Film [Suboxone]",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1010604,
      drugName: "Buprenorphine 8 MG / Naloxone 2 MG Sublingual Film",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1010606,
      drugName: "Buprenorphine 8 MG / Naloxone 2 MG Sublingual Film [Suboxone]",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8 MG",
      strengthValue: 8.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1010608,
      drugName:
        "Buprenorphine 2 MG / Naloxone 0.5 MG Sublingual Tablet [Suboxone]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2 MG",
      strengthValue: 2.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1014599,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2279510,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 10 MG Oral Tablet [Prolate]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1014615,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2279512,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 5 MG Oral Tablet [Prolate]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1014632,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 7.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1037259,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 2.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1042693,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1044427,
      drugName:
        "Acetaminophen 20 MG/ML / Hydrocodone Bitartrate 0.667 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.667 MG/ML",
      strengthValue: 0.667,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1049214,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049216,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 10 MG Oral Tablet [Endocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049221,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049223,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 5 MG Oral Tablet [Endocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049225,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 7.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049227,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 7.5 MG Oral Tablet [Endocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049251,
      drugName:
        "Acetaminophen 400 MG / Oxycodone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049260,
      drugName:
        "Acetaminophen 400 MG / Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049502,
      drugName:
        "12 HR Oxycodone Hydrochloride 10 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049504,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 10 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049543,
      drugName:
        "12 HR Oxycodone Hydrochloride 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049545,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 15 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049565,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 20 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049574,
      drugName:
        "12 HR Oxycodone Hydrochloride 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049576,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 30 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049580,
      drugName:
        "Acetaminophen 65 MG/ML / Oxycodone Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1049586,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 40 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049589,
      drugName: "Ibuprofen 400 MG / Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049593,
      drugName:
        "12 HR Oxycodone Hydrochloride 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049595,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 60 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049601,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 80 MG Extended Release Oral Tablet [Oxycontin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049604,
      drugName: "Oxycodone Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1049611,
      drugName: "Oxycodone Hydrochloride 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049613,
      drugName: "Oxycodone Hydrochloride 15 MG Oral Tablet [Roxicodone]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049615,
      drugName: "Oxycodone Hydrochloride 20 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "20 MG/ML",
      strengthValue: 20.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1049618,
      drugName: "Oxycodone Hydrochloride 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049620,
      drugName: "Oxycodone Hydrochloride 30 MG Oral Tablet [Roxicodone]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049621,
      drugName: "Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049623,
      drugName: "Oxycodone Hydrochloride 5 MG Oral Tablet [Roxicodone]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049625,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 10 MG Oral Tablet [Percocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049635,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 2.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049637,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 2.5 MG Oral Tablet [Percocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049640,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 5 MG Oral Tablet [Percocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049642,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 7.5 MG Oral Tablet [Percocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049683,
      drugName: "Oxycodone Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049686,
      drugName: "Oxycodone Hydrochloride 20 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049691,
      drugName: "Aspirin 325 MG / Oxycodone Hydrochloride 5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1049696,
      drugName: "Oxycodone Hydrochloride 5 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053647,
      drugName: "Fentanyl 0.1 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG",
      strengthValue: 0.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053651,
      drugName: "Fentanyl 0.1 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG",
      strengthValue: 0.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053652,
      drugName: "Fentanyl 0.2 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053654,
      drugName: "Fentanyl 0.2 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG",
      strengthValue: 0.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053655,
      drugName: "Fentanyl 0.3 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.3 MG",
      strengthValue: 0.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053657,
      drugName: "Fentanyl 0.3 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.3 MG",
      strengthValue: 0.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053658,
      drugName: "Fentanyl 0.4 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053660,
      drugName: "Fentanyl 0.4 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG",
      strengthValue: 0.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053661,
      drugName: "Fentanyl 0.6 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053663,
      drugName: "Fentanyl 0.6 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053664,
      drugName: "Fentanyl 0.8 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 1053666,
      drugName: "Fentanyl 0.8 MG Sublingual Tablet [Abstral]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG",
      strengthValue: 0.8,
      strengthUnit: "MG",
    },
    {
      drugCode: 1086926,
      drugName:
        "Codeine Phosphate 1.26 MG/ML / Guaifenesin 20 MG/ML Oral Solution [Relcof C]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.26 MG/ML",
      strengthValue: 1.26,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1087389,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 4 MG / HYDROCODONE POLISTIREX 5 MG Extended Release Oral Capsule [TussiCaps]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1087427,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 8 MG / HYDROCODONE POLISTIREX 10 MG Extended Release Oral Capsule [TussiCaps]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1087459,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 1.6 MG/ML / HYDROCODONE POLISTIREX 2 MG/ML Extended Release Suspension",
      doseFormCode: 316946,
      doseFormName: "Extended Release Suspension",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1087463,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 1.6 MG/ML / HYDROCODONE POLISTIREX 2 MG/ML Extended Release Suspension [Tussionex]",
      doseFormCode: 316946,
      doseFormName: "Extended Release Suspension",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1089055,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 20 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089057,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 20 MG Oral Tablet [Ambifed-G CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089058,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089060,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 30 MG Oral Tablet [Ambifed CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089061,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 40 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089063,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 40 MG Oral Tablet [Maxifed-G CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089070,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1089072,
      drugName:
        "Codeine Phosphate 10 MG / Guaifenesin 400 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet [Maxifed CD]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1099711,
      drugName:
        "Codeine Phosphate 20 MG / Pseudoephedrine Hydrochloride 60 MG / Triprolidine Hydrochloride 4 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1112220,
      drugName:
        "Chlorpheniramine Maleate 0.8 MG/ML / Hydrocodone Bitartrate 1 MG/ML / Pseudoephedrine Hydrochloride 12 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1112224,
      drugName:
        "Chlorpheniramine Maleate 0.8 MG/ML / Hydrocodone Bitartrate 1 MG/ML / Pseudoephedrine Hydrochloride 12 MG/ML Oral Solution [Zutripro]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1113314,
      drugName: "Oxycodone Hydrochloride 7.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1113417,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 2 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1113437,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 2 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Phenylhistine DH]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1113998,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / Codeine Phosphate 1.6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.6 MG/ML",
      strengthValue: 1.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1114026,
      drugName:
        "Codeine Phosphate 1.6 MG/ML / Guaifenesin 40 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.6 MG/ML",
      strengthValue: 1.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1114334,
      drugName:
        "Hydrocodone Bitartrate 1 MG/ML / Pseudoephedrine Hydrochloride 12 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1114338,
      drugName:
        "Hydrocodone Bitartrate 1 MG/ML / Pseudoephedrine Hydrochloride 12 MG/ML Oral Solution [Rezira]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1114878,
      drugName:
        "Codeine Phosphate 1.6 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.6 MG/ML",
      strengthValue: 1.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1115573,
      drugName: "Fentanyl 0.1 MG/ACTUAT Metered Dose Nasal Spray",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/ACTUAT",
      strengthValue: 0.1,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1115575,
      drugName: "Fentanyl 0.1 MG/ACTUAT Metered Dose Nasal Spray [Lazanda]",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/ACTUAT",
      strengthValue: 0.1,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1115577,
      drugName: "Fentanyl 0.4 MG/ACTUAT Metered Dose Nasal Spray",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG/ACTUAT",
      strengthValue: 0.4,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1115579,
      drugName: "Fentanyl 0.4 MG/ACTUAT Metered Dose Nasal Spray [Lazanda]",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG/ACTUAT",
      strengthValue: 0.4,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1147395,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 10 MG Oral Tablet [Xodol]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148478,
      drugName:
        "24 HR tramadol hydrochloride 100 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148482,
      drugName:
        "24 HR tramadol hydrochloride 100 MG Extended Release Oral Capsule [ConZip]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148485,
      drugName:
        "24 HR tramadol hydrochloride 200 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148487,
      drugName:
        "24 HR tramadol hydrochloride 200 MG Extended Release Oral Capsule [ConZip]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148489,
      drugName:
        "24 HR tramadol hydrochloride 300 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "300 MG",
      strengthValue: 300.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148491,
      drugName:
        "24 HR tramadol hydrochloride 300 MG Extended Release Oral Capsule [ConZip]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "300 MG",
      strengthValue: 300.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148797,
      drugName: "12 HR tapentadol 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148800,
      drugName: "12 HR tapentadol 150 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "150 MG",
      strengthValue: 150.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148803,
      drugName: "12 HR tapentadol 200 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148807,
      drugName: "12 HR tapentadol 250 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "250 MG",
      strengthValue: 250.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1148809,
      drugName: "12 HR tapentadol 50 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1149367,
      drugName:
        "12 HR tapentadol 100 MG Extended Release Oral Tablet [Nucynta]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1149370,
      drugName:
        "12 HR tapentadol 150 MG Extended Release Oral Tablet [Nucynta]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "150 MG",
      strengthValue: 150.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1149373,
      drugName:
        "12 HR tapentadol 200 MG Extended Release Oral Tablet [Nucynta]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1149376,
      drugName:
        "12 HR tapentadol 250 MG Extended Release Oral Tablet [Nucynta]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "250 MG",
      strengthValue: 250.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1149378,
      drugName: "12 HR tapentadol 50 MG Extended Release Oral Tablet [Nucynta]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 787390,
      ingredientName: "tapentadol",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1190201,
      drugName:
        "Acetaminophen 320.5 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule [Trezix]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1190572,
      drugName:
        "Atropine sulfate 0.025 MG / Diphenoxylate hydrochloride 2.5 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3500,
      ingredientName: "diphenoxylate",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1190580,
      drugName:
        "Codeine Phosphate 1.2 MG/ML / Dexbrompheniramine maleate 0.133 MG/ML / Pseudoephedrine Hydrochloride 4 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.2 MG/ML",
      strengthValue: 1.2,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1190587,
      drugName:
        "Codeine Phosphate 1.2 MG/ML / Dexbrompheniramine maleate 0.133 MG/ML / Pseudoephedrine Hydrochloride 4 MG/ML Oral Solution [M-End Max D]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.2 MG/ML",
      strengthValue: 1.2,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1190641,
      drugName:
        "Atropine sulfate 0.025 MG / Diphenoxylate hydrochloride 2.5 MG Oral Tablet [Lomotil]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3500,
      ingredientName: "diphenoxylate",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1190646,
      drugName:
        "Atropine sulfate 0.025 MG / Diphenoxylate hydrochloride 2.5 MG Oral Tablet [Lonox]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 3500,
      ingredientName: "diphenoxylate",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1232113,
      drugName: "1 ML Morphine Sulfate 15 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG/ML",
      strengthValue: 15.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1234872,
      drugName:
        "Aspirin 356.4 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1234941,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / dihydrocodeine bitartrate 0.6 MG/ML / Phenylephrine Hydrochloride 1.5 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "0.6 MG/ML",
      strengthValue: 0.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1234957,
      drugName:
        "Chlorpheniramine Maleate 0.4 MG/ML / dihydrocodeine bitartrate 0.6 MG/ML / Phenylephrine Hydrochloride 1.5 MG/ML Oral Solution [ColdCough PD]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "0.6 MG/ML",
      strengthValue: 0.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1234976,
      drugName:
        "Aspirin 356.4 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule [Synalgos-DC]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1235862,
      drugName:
        "Chlorcyclizine hydrochloride 2.5 MG/ML / Codeine Phosphate 1.8 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1236239,
      drugName: "dihydrocodeine bitartrate 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1237050,
      drugName: "Fentanyl 0.1 MG/ACTUAT Mucosal Spray",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/ACTUAT",
      strengthValue: 0.1,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237055,
      drugName: "Fentanyl 0.1 MG/ACTUAT Mucosal Spray [Subsys]",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.1 MG/ACTUAT",
      strengthValue: 0.1,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237057,
      drugName: "Fentanyl 0.2 MG/ACTUAT Mucosal Spray",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG/ACTUAT",
      strengthValue: 0.2,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237059,
      drugName: "Fentanyl 0.2 MG/ACTUAT Mucosal Spray [Subsys]",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.2 MG/ACTUAT",
      strengthValue: 0.2,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237060,
      drugName: "Fentanyl 0.4 MG/ACTUAT Mucosal Spray",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG/ACTUAT",
      strengthValue: 0.4,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237062,
      drugName: "Fentanyl 0.4 MG/ACTUAT Mucosal Spray [Subsys]",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.4 MG/ACTUAT",
      strengthValue: 0.4,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237064,
      drugName: "Fentanyl 0.6 MG/ACTUAT Mucosal Spray",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG/ACTUAT",
      strengthValue: 0.6,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237066,
      drugName: "Fentanyl 0.6 MG/ACTUAT Mucosal Spray [Subsys]",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG/ACTUAT",
      strengthValue: 0.6,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237068,
      drugName: "Fentanyl 0.8 MG/ACTUAT Mucosal Spray",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG/ACTUAT",
      strengthValue: 0.8,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1237070,
      drugName: "Fentanyl 0.8 MG/ACTUAT Mucosal Spray [Subsys]",
      doseFormCode: 346163,
      doseFormName: "Mucosal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG/ACTUAT",
      strengthValue: 0.8,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1242106,
      drugName: "1 ML Meperidine Hydrochloride 100 MG/ML Cartridge [Demerol]",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1242503,
      drugName: "1 ML Meperidine Hydrochloride 25 MG/ML Cartridge [Demerol]",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1242558,
      drugName:
        "Chlorcyclizine hydrochloride 2.5 MG/ML / Codeine Phosphate 1.8 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Statuss Green Reformulated Jan 2012]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1244921,
      drugName:
        "Brompheniramine Maleate 0.266 MG/ML / Codeine Phosphate 1.27 MG/ML / Phenylephrine Hydrochloride 0.666 MG/ML Oral Solution [M-End PE]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.27 MG/ML",
      strengthValue: 1.27,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1248115,
      drugName:
        "24 HR tramadol hydrochloride 150 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "150 MG",
      strengthValue: 150.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1303736,
      drugName: "Morphine Sulfate 40 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1303738,
      drugName: "Morphine Sulfate 40 MG Extended Release Oral Capsule [Kadian]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1306898,
      drugName:
        "24 HR Hydromorphone Hydrochloride 32 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "32 MG",
      strengthValue: 32.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1306900,
      drugName:
        "24 HR Hydromorphone Hydrochloride 32 MG Extended Release Oral Tablet [Exalgo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "32 MG",
      strengthValue: 32.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1307056,
      drugName: "Buprenorphine 4 MG / Naloxone 1 MG Sublingual Film",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "4 MG",
      strengthValue: 4.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1307058,
      drugName: "Buprenorphine 4 MG / Naloxone 1 MG Sublingual Film [Suboxone]",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "4 MG",
      strengthValue: 4.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1307061,
      drugName: "Buprenorphine 12 MG / Naloxone 3 MG Sublingual Film",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "12 MG",
      strengthValue: 12.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1307063,
      drugName:
        "Buprenorphine 12 MG / Naloxone 3 MG Sublingual Film [Suboxone]",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "12 MG",
      strengthValue: 12.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1310202,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 5 MG Oral Tablet [Vicodin]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1310212,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet [Vicodin]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1310270,
      drugName:
        "Acetaminophen 300 MG / Hydrocodone Bitartrate 10 MG Oral Tablet [Vicodin]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356797,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 10 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356799,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 10 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet [Brovex PBC]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356800,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356802,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 10 MG Oral Tablet [BroveX CB]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356804,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 20 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356806,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 20 MG / Phenylephrine Hydrochloride 10 MG Oral Tablet [Brovex PBC]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356807,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 20 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1356809,
      drugName:
        "Brompheniramine Maleate 4 MG / Codeine Phosphate 20 MG Oral Tablet [BroveX CB]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1366873,
      drugName:
        "Hydrocodone Bitartrate 5 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1366875,
      drugName:
        "Hydrocodone Bitartrate 5 MG / Pseudoephedrine Hydrochloride 60 MG Oral Tablet [P-V-Tussin]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1372265,
      drugName:
        "Chlorpheniramine Maleate 0.8 MG/ML / Hydrocodone Bitartrate 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1372873,
      drugName:
        "Chlorpheniramine Maleate 0.8 MG/ML / Hydrocodone Bitartrate 1 MG/ML Oral Solution [Vituz]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1431076,
      drugName: "Buprenorphine 1.4 MG / Naloxone 0.36 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "1.4 MG",
      strengthValue: 1.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1431083,
      drugName:
        "Buprenorphine 1.4 MG / Naloxone 0.36 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "1.4 MG",
      strengthValue: 1.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1431102,
      drugName: "Buprenorphine 5.7 MG / Naloxone 1.4 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "5.7 MG",
      strengthValue: 5.7,
      strengthUnit: "MG",
    },
    {
      drugCode: 1431104,
      drugName:
        "Buprenorphine 5.7 MG / Naloxone 1.4 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "5.7 MG",
      strengthValue: 5.7,
      strengthUnit: "MG",
    },
    {
      drugCode: 1431286,
      drugName:
        "Acetaminophen 300 MG / butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1432969,
      drugName: "168 HR Buprenorphine 0.015 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.015 MG/HR",
      strengthValue: 0.015,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1432971,
      drugName: "168 HR Buprenorphine 0.015 MG/HR Transdermal System [BuTrans]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.015 MG/HR",
      strengthValue: 0.015,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1433251,
      drugName: "0.5 ML Hydromorphone Hydrochloride 1 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1433802,
      drugName:
        "Acetaminophen 300 MG / butalbital 50 MG / Caffeine 40 MG / Codeine Phosphate 30 MG Oral Capsule [Fioricet with Codeine]",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1440003,
      drugName:
        "Codeine Phosphate 1.8 MG/ML / Dexchlorpheniramine maleate 0.2 MG/ML / Phenylephrine Hydrochloride 1 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.8 MG/ML",
      strengthValue: 1.8,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1442445,
      drugName:
        "Acetaminophen 20 MG/ML / Hydrocodone Bitartrate 0.667 MG/ML Oral Solution [Lortab]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.667 MG/ML",
      strengthValue: 0.667,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1442790,
      drugName: "1 ML Morphine Sulfate 5 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG/ML",
      strengthValue: 5.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1487288,
      drugName:
        "Acetaminophen 325 MG / Oxycodone Hydrochloride 2.5 MG Oral Tablet [Endocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1491832,
      drugName:
        "12 HR Acetaminophen 325 MG / Oxycodone Hydrochloride 7.5 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1491834,
      drugName:
        "12 HR Acetaminophen 325 MG / Oxycodone Hydrochloride 7.5 MG Extended Release Oral Tablet [Xartemis]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1492671,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 10 MG Oral Tablet [Lorcet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1492673,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 5 MG Oral Tablet [Lorcet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1492675,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet [Lorcet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1495472,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 10 MG Oral Tablet [Lortab]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1495474,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 5 MG Oral Tablet [Lortab]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1495476,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 7.5 MG Oral Tablet [Lortab]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1537116,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 5 MG Oral Tablet [Primlev]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1537120,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 10 MG Oral Tablet [Primlev]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1537122,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 7.5 MG Oral Tablet [Primlev]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1541630,
      drugName:
        "Brompheniramine Maleate 0.8 MG/ML / Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1542390,
      drugName: "Buprenorphine 2.1 MG / Naloxone 0.3 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2.1 MG",
      strengthValue: 2.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 1542396,
      drugName: "Buprenorphine 2.1 MG / Naloxone 0.3 MG Buccal Film [Bunavail]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2.1 MG",
      strengthValue: 2.1,
      strengthUnit: "MG",
    },
    {
      drugCode: 1542981,
      drugName:
        "Acetaminophen 325 MG / Hydrocodone Bitartrate 2.5 MG Oral Tablet [Verdrocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1542988,
      drugName:
        "Hydrocodone Bitartrate 10 MG / Ibuprofen 200 MG Oral Tablet [Xylon]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1542997,
      drugName: "168 HR Buprenorphine 0.0075 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.0075 MG/HR",
      strengthValue: 0.0075,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1542999,
      drugName:
        "168 HR Buprenorphine 0.0075 MG/HR Transdermal System [BuTrans]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.0075 MG/HR",
      strengthValue: 0.0075,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1544851,
      drugName: "Buprenorphine 4.2 MG / Naloxone 0.7 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "4.2 MG",
      strengthValue: 4.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1544853,
      drugName: "Buprenorphine 4.2 MG / Naloxone 0.7 MG Buccal Film [Bunavail]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "4.2 MG",
      strengthValue: 4.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1544854,
      drugName: "Buprenorphine 6.3 MG / Naloxone 1 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "6.3 MG",
      strengthValue: 6.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1544856,
      drugName: "Buprenorphine 6.3 MG / Naloxone 1 MG Buccal Film [Bunavail]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "6.3 MG",
      strengthValue: 6.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1547607,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 20 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Lortuss EX]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1595214,
      drugName:
        "Codeine Phosphate 1.6 MG/ML / Guaifenesin 40 MG/ML Oral Solution [Ninjacof XG]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "1.6 MG/ML",
      strengthValue: 1.6,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1595730,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 20 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595736,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 20 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595740,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595742,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 30 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595746,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 40 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595748,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 40 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595752,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595754,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 60 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595758,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 80 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595760,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 80 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595764,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595766,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 100 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595770,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 120 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "120 MG",
      strengthValue: 120.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1595772,
      drugName:
        "Abuse-Deterrent 24 HR Hydrocodone Bitartrate 120 MG Extended Release Oral Tablet [Hysingla]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "120 MG",
      strengthValue: 120.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1596108,
      drugName:
        "Acetaminophen 320.5 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule",
      doseFormCode: 316965,
      doseFormName: "Oral Capsule",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1597568,
      drugName: "Buprenorphine 11.4 MG / Naloxone 2.9 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "11.4 MG",
      strengthValue: 11.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1597570,
      drugName:
        "Buprenorphine 11.4 MG / Naloxone 2.9 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "11.4 MG",
      strengthValue: 11.4,
      strengthUnit: "MG",
    },
    {
      drugCode: 1597573,
      drugName: "Buprenorphine 8.6 MG / Naloxone 2.1 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8.6 MG",
      strengthValue: 8.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1597575,
      drugName:
        "Buprenorphine 8.6 MG / Naloxone 2.1 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "8.6 MG",
      strengthValue: 8.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1598284,
      drugName:
        "Guaifenesin 40 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution [Obredon]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1603495,
      drugName: "72 HR Fentanyl 0.0375 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.0375 MG/HR",
      strengthValue: 0.0375,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1603498,
      drugName: "72 HR Fentanyl 0.0625 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.0625 MG/HR",
      strengthValue: 0.0625,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1603501,
      drugName: "72 HR Fentanyl 0.0875 MG/HR Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.0875 MG/HR",
      strengthValue: 0.0875,
      strengthUnit: "MG/HR",
    },
    {
      drugCode: 1650982,
      drugName:
        "Guaifenesin 40 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML Oral Solution [Flowtuss]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1651558,
      drugName:
        "Guaifenesin 40 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1651564,
      drugName:
        "Guaifenesin 40 MG/ML / Hydrocodone Bitartrate 0.5 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution [Hycofenix]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1652087,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 0.8 MG/ML / CODEINE POLISTIREX 4 MG/ML Extended Release Suspension",
      doseFormCode: 316946,
      doseFormName: "Extended Release Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1652093,
      drugName:
        "12 HR CHLORPHENIRAMINE POLISTIREX 0.8 MG/ML / CODEINE POLISTIREX 4 MG/ML Extended Release Suspension [Tuzistra]",
      doseFormCode: 316946,
      doseFormName: "Extended Release Suspension",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1655032,
      drugName: "1 ML Buprenorphine 0.3 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.3 MG/ML",
      strengthValue: 0.3,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1655058,
      drugName: "Meperidine Hydrochloride 150 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "150 MG",
      strengthValue: 150.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1655060,
      drugName: "Meperidine Hydrochloride 75 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "75 MG",
      strengthValue: 75.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1661319,
      drugName:
        "Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 2 MG/ML / Triprolidine Hydrochloride 0.5 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1661325,
      drugName:
        "Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 2 MG/ML / Triprolidine Hydrochloride 0.5 MG/ML Oral Solution [Histex AC]",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1664448,
      drugName: "Oxycodone Hydrochloride 5 MG Oral Tablet [Oxaydo]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "5 MG",
      strengthValue: 5.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1664543,
      drugName:
        "12 HR Chlorpheniramine Maleate 8 MG / Codeine Phosphate 54.3 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "54.3 MG",
      strengthValue: 54.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1664634,
      drugName: "Oxycodone Hydrochloride 7.5 MG Oral Tablet [Oxaydo]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "7.5 MG",
      strengthValue: 7.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1665685,
      drugName: "1 ML Meperidine Hydrochloride 100 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665687,
      drugName: "1 ML Meperidine Hydrochloride 100 MG/ML Injection [Demerol]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "100 MG/ML",
      strengthValue: 100.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665690,
      drugName: "1.5 ML Meperidine Hydrochloride 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665691,
      drugName: "1.5 ML Meperidine Hydrochloride 50 MG/ML Injection [Demerol]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665697,
      drugName: "1 ML Meperidine Hydrochloride 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665698,
      drugName: "1 ML Meperidine Hydrochloride 50 MG/ML Injection [Demerol]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665699,
      drugName: "0.5 ML Meperidine Hydrochloride 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665700,
      drugName: "0.5 ML Meperidine Hydrochloride 50 MG/ML Injection [Demerol]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665701,
      drugName: "2 ML Meperidine Hydrochloride 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1665702,
      drugName: "2 ML Meperidine Hydrochloride 50 MG/ML Injection [Demerol]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 6754,
      ingredientName: "Meperidine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1666338,
      drugName: "Buprenorphine 2.9 MG / Naloxone 0.71 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2.9 MG",
      strengthValue: 2.9,
      strengthUnit: "MG",
    },
    {
      drugCode: 1666385,
      drugName:
        "Buprenorphine 2.9 MG / Naloxone 0.71 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "2.9 MG",
      strengthValue: 2.9,
      strengthUnit: "MG",
    },
    {
      drugCode: 1666831,
      drugName: "80 ACTUAT Fentanyl 0.04 MG/ACTUAT Transdermal System",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.04 MG/ACTUAT",
      strengthValue: 0.04,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1666837,
      drugName: "80 ACTUAT Fentanyl 0.04 MG/ACTUAT Transdermal System [Ionsys]",
      doseFormCode: 316987,
      doseFormName: "Transdermal System",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.04 MG/ACTUAT",
      strengthValue: 0.04,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1716057,
      drugName: "Buprenorphine 0.15 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.15 MG",
      strengthValue: 0.15,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716063,
      drugName: "Buprenorphine 0.15 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.15 MG",
      strengthValue: 0.15,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716065,
      drugName: "Buprenorphine 0.3 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.3 MG",
      strengthValue: 0.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716067,
      drugName: "Buprenorphine 0.3 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.3 MG",
      strengthValue: 0.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716069,
      drugName: "Buprenorphine 0.45 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.45 MG",
      strengthValue: 0.45,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716071,
      drugName: "Buprenorphine 0.45 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.45 MG",
      strengthValue: 0.45,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716073,
      drugName: "Buprenorphine 0.6 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716075,
      drugName: "Buprenorphine 0.6 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.6 MG",
      strengthValue: 0.6,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716077,
      drugName: "Buprenorphine 0.075 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.075 MG",
      strengthValue: 0.075,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716079,
      drugName: "Buprenorphine 0.075 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.075 MG",
      strengthValue: 0.075,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716081,
      drugName: "Buprenorphine 0.75 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.75 MG",
      strengthValue: 0.75,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716083,
      drugName: "Buprenorphine 0.75 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.75 MG",
      strengthValue: 0.75,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716086,
      drugName: "Buprenorphine 0.9 MG Buccal Film",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.9 MG",
      strengthValue: 0.9,
      strengthUnit: "MG",
    },
    {
      drugCode: 1716090,
      drugName: "Buprenorphine 0.9 MG Buccal Film [Belbuca]",
      doseFormCode: 858080,
      doseFormName: "Buccal Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.9 MG",
      strengthValue: 0.9,
      strengthUnit: "MG",
    },
    {
      drugCode: 1723209,
      drugName: "20 ML Alfentanil 0.5 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 480,
      ingredientName: "Alfentanil",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724276,
      drugName: "1 ML Hydromorphone Hydrochloride 2 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724338,
      drugName: "1 ML Hydromorphone Hydrochloride 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724340,
      drugName: "5 ML Hydromorphone Hydrochloride 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724341,
      drugName: "50 ML Hydromorphone Hydrochloride 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724383,
      drugName: "1 ML Hydromorphone Hydrochloride 1 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1724644,
      drugName: "1 ML Hydromorphone Hydrochloride 2 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728351,
      drugName: "1 ML Butorphanol Tartrate 2 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728355,
      drugName: "2 ML Butorphanol Tartrate 2 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 1841,
      ingredientName: "Butorphanol",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728783,
      drugName: "10 ML Morphine Sulfate 0.5 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728784,
      drugName: "10 ML Morphine Sulfate 0.5 MG/ML Injection [Astramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728791,
      drugName: "2 ML Morphine Sulfate 0.5 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728792,
      drugName: "2 ML Morphine Sulfate 0.5 MG/ML Injection [Astramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "0.5 MG/ML",
      strengthValue: 0.5,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728800,
      drugName: "10 ML Morphine Sulfate 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728801,
      drugName: "10 ML Morphine Sulfate 1 MG/ML Injection [Astramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728805,
      drugName: "2 ML Morphine Sulfate 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728806,
      drugName: "2 ML Morphine Sulfate 1 MG/ML Injection [Astramorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1728999,
      drugName: "30 ML Morphine Sulfate 1 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1729197,
      drugName: "1 ML Morphine Sulfate 2 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1729320,
      drugName: "Fentanyl 0.3 MG/ACTUAT Metered Dose Nasal Spray",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.3 MG/ACTUAT",
      strengthValue: 0.3,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1729322,
      drugName: "Fentanyl 0.3 MG/ACTUAT Metered Dose Nasal Spray [Lazanda]",
      doseFormCode: 1797831,
      doseFormName: "Metered Dose Nasal Spray",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.3 MG/ACTUAT",
      strengthValue: 0.3,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1729581,
      drugName: "Remifentanil 1 MG Injection [Ultiva]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 73032,
      ingredientName: "Remifentanil",
      strength: "1 MG",
      strengthValue: 1.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1731517,
      drugName: "10 ML Morphine Sulfate 25 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731520,
      drugName: "4 ML Morphine Sulfate 25 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731522,
      drugName: "20 ML Morphine Sulfate 25 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731530,
      drugName: "1 ML Morphine Sulfate 15 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG/ML",
      strengthValue: 15.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731537,
      drugName: "20 ML Morphine Sulfate 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731545,
      drugName: "50 ML Morphine Sulfate 50 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "50 MG/ML",
      strengthValue: 50.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731993,
      drugName: "1 ML Morphine Sulfate 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731995,
      drugName: "1 ML Morphine Sulfate 10 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731998,
      drugName: "20 ML Morphine Sulfate 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1731999,
      drugName: "20 ML Morphine Sulfate 10 MG/ML Injection [Infumorph]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732003,
      drugName: "1 ML Morphine Sulfate 8 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "8 MG/ML",
      strengthValue: 8.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732006,
      drugName: "1 ML Morphine Sulfate 4 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732011,
      drugName: "1 ML Morphine Sulfate 8 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "8 MG/ML",
      strengthValue: 8.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732014,
      drugName: "1 ML Morphine Sulfate 4 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732136,
      drugName: "1 ML Morphine Sulfate 5 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG/ML",
      strengthValue: 5.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1732138,
      drugName: "30 ML Morphine Sulfate 5 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "5 MG/ML",
      strengthValue: 5.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1733080,
      drugName: "1 ML Morphine Sulfate 15 MG/ML Cartridge",
      doseFormCode: 1649572,
      doseFormName: "Cartridge",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG/ML",
      strengthValue: 15.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1735003,
      drugName: "2 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1735006,
      drugName: "10 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1735007,
      drugName: "5 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1735008,
      drugName: "20 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1735013,
      drugName: "50 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1740007,
      drugName: "{2 (Fentanyl 0.6 MG/ACTUAT Mucosal Spray) } Pack",
      doseFormCode: 746839,
      doseFormName: "Pack",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG/ACTUAT",
      strengthValue: 0.6,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1740008,
      drugName:
        "{2 (Fentanyl 0.6 MG/ACTUAT Mucosal Spray [Subsys]) } Pack [Subsys 1200 MCG]",
      doseFormCode: 746839,
      doseFormName: "Pack",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.6 MG/ACTUAT",
      strengthValue: 0.6,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1740009,
      drugName: "{2 (Fentanyl 0.8 MG/ACTUAT Mucosal Spray) } Pack",
      doseFormCode: 746839,
      doseFormName: "Pack",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG/ACTUAT",
      strengthValue: 0.8,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1740010,
      drugName:
        "{2 (Fentanyl 0.8 MG/ACTUAT Mucosal Spray [Subsys]) } Pack [Subsys 1600 MCG]",
      doseFormCode: 746839,
      doseFormName: "Pack",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.8 MG/ACTUAT",
      strengthValue: 0.8,
      strengthUnit: "MG/ACTUAT",
    },
    {
      drugCode: 1745881,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 15 MG Extended Release Oral Tablet [Morphabond]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1745886,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 100 MG Extended Release Oral Tablet [Morphabond]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1745889,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 30 MG Extended Release Oral Tablet [Morphabond]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1745892,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 60 MG Extended Release Oral Tablet [Morphabond]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1790527,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 9 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "9 MG",
      strengthValue: 9.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1790533,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 9 MG Extended Release Oral Capsule [Xtampza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "9 MG",
      strengthValue: 9.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791558,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 13.5 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "13.5 MG",
      strengthValue: 13.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791560,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 13.5 MG Extended Release Oral Capsule [Xtampza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "13.5 MG",
      strengthValue: 13.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791567,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 18 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "18 MG",
      strengthValue: 18.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791569,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 18 MG Extended Release Oral Capsule [Xtampza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "18 MG",
      strengthValue: 18.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791574,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 27 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "27 MG",
      strengthValue: 27.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791576,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 27 MG Extended Release Oral Capsule [Xtampza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "27 MG",
      strengthValue: 27.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791580,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 36 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "36 MG",
      strengthValue: 36.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1791582,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone 36 MG Extended Release Oral Capsule [Xtampza]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "36 MG",
      strengthValue: 36.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1792707,
      drugName:
        "Codeine Phosphate 2 MG/ML / Guaifenesin 40 MG/ML / Pseudoephedrine Hydrochloride 6 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1797650,
      drugName: "Buprenorphine 74.2 MG Drug Implant",
      doseFormCode: 657710,
      doseFormName: "Drug Implant",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "74.2 MG",
      strengthValue: 74.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1797655,
      drugName: "Buprenorphine 74.2 MG Drug Implant [Probuphine]",
      doseFormCode: 657710,
      doseFormName: "Drug Implant",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "74.2 MG",
      strengthValue: 74.2,
      strengthUnit: "MG",
    },
    {
      drugCode: 1811473,
      drugName: "1 ML Pentazocine 30 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 8001,
      ingredientName: "Pentazocine",
      strength: "30 MG/ML",
      strengthValue: 30.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1811475,
      drugName: "1 ML Pentazocine 30 MG/ML Injection [Talwin]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 8001,
      ingredientName: "Pentazocine",
      strength: "30 MG/ML",
      strengthValue: 30.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1809102,
      drugName: "2 ML Sufentanil 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 56795,
      ingredientName: "Sufentanil",
      strength: " 0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1812164,
      drugName:
        "Acetaminophen 325 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860127,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860129,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 20 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860137,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 40 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860148,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 80 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "80 MG",
      strengthValue: 80.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860151,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860154,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860157,
      drugName:
        "Abuse-Deterrent 12 HR Oxycodone Hydrochloride 10 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860491,
      drugName:
        "12 HR Hydrocodone Bitartrate 10 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860492,
      drugName:
        "12 HR Hydrocodone Bitartrate 10 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "10 MG",
      strengthValue: 10.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860493,
      drugName:
        "12 HR Hydrocodone Bitartrate 15 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860494,
      drugName:
        "12 HR Hydrocodone Bitartrate 15 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860495,
      drugName:
        "12 HR Hydrocodone Bitartrate 20 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860496,
      drugName:
        "12 HR Hydrocodone Bitartrate 20 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860497,
      drugName:
        "12 HR Hydrocodone Bitartrate 30 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860498,
      drugName:
        "12 HR Hydrocodone Bitartrate 30 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860499,
      drugName:
        "12 HR Hydrocodone Bitartrate 40 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860500,
      drugName:
        "12 HR Hydrocodone Bitartrate 40 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860501,
      drugName:
        "12 HR Hydrocodone Bitartrate 50 MG Extended Release Oral Capsule",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1860502,
      drugName:
        "12 HR Hydrocodone Bitartrate 50 MG Extended Release Oral Capsule [Zohydro]",
      doseFormCode: 316943,
      doseFormName: "Extended Release Oral Capsule",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "50 MG",
      strengthValue: 50.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1864412,
      drugName: "Buprenorphine 0.7 MG / Naloxone 0.18 MG Sublingual Tablet",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.7 MG",
      strengthValue: 0.7,
      strengthUnit: "MG",
    },
    {
      drugCode: 1864414,
      drugName:
        "Buprenorphine 0.7 MG / Naloxone 0.18 MG Sublingual Tablet [Zubsolv]",
      doseFormCode: 317007,
      doseFormName: "Sublingual Tablet",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "0.7 MG",
      strengthValue: 0.7,
      strengthUnit: "MG",
    },
    {
      drugCode: 1866543,
      drugName: "1 ML Nalbuphine Hydrochloride 10 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7238,
      ingredientName: "Nalbuphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1866551,
      drugName: "1 ML Nalbuphine Hydrochloride 20 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7238,
      ingredientName: "Nalbuphine",
      strength: "20 MG/ML",
      strengthValue: 20.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1871434,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 15 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1871440,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 15 MG Extended Release Oral Tablet [Arymo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1871441,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 30 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1871443,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 30 MG Extended Release Oral Tablet [Arymo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1871444,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 60 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1871446,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 60 MG Extended Release Oral Tablet [Arymo]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "60 MG",
      strengthValue: 60.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1872234,
      drugName:
        "Abuse-Deterrent 12 HR Morphine Sulfate 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1872265,
      drugName:
        "1 ML Hydromorphone Hydrochloride 1 MG/ML Prefilled Syringe [Dilaudid]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1872269,
      drugName:
        "1 ML Hydromorphone Hydrochloride 2 MG/ML Prefilled Syringe [Dilaudid]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1872271,
      drugName: "1 ML Hydromorphone Hydrochloride 4 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1872272,
      drugName:
        "1 ML Hydromorphone Hydrochloride 4 MG/ML Prefilled Syringe [Dilaudid]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "4 MG/ML",
      strengthValue: 4.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1872752,
      drugName:
        "0.5 ML Hydromorphone Hydrochloride 1 MG/ML Prefilled Syringe [Dilaudid]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 3423,
      ingredientName: "Hydromorphone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1944529,
      drugName: "Abuse-Deterrent Oxycodone Hydrochloride 15 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "15 MG",
      strengthValue: 15.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1944538,
      drugName: "Abuse-Deterrent Oxycodone Hydrochloride 30 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "30 MG",
      strengthValue: 30.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1946525,
      drugName:
        "Matrix Delivery 24 HR tramadol hydrochloride 300 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "300 MG",
      strengthValue: 300.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1946527,
      drugName:
        "Matrix Delivery 24 HR tramadol hydrochloride 200 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "200 MG",
      strengthValue: 200.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1946529,
      drugName:
        "Matrix Delivery 24 HR tramadol hydrochloride 100 MG Extended Release Oral Tablet",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1990745,
      drugName:
        "Methadone Hydrochloride 40 MG Tablet for Oral Suspension [Diskets]",
      doseFormCode: 1861409,
      doseFormName: "Tablet for Oral Suspension",
      ingredientCode: 6813,
      ingredientName: "Methadone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1995536,
      drugName:
        "Acetaminophen 325 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Tablet [Panlor Reformulated Jan 2018]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 1996184,
      drugName: "0.5 ML Buprenorphine 200 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "200 MG/ML",
      strengthValue: 200.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1996189,
      drugName: "0.5 ML Buprenorphine 200 MG/ML Prefilled Syringe [Sublocade]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "200 MG/ML",
      strengthValue: 200.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1996192,
      drugName: "1.5 ML Buprenorphine 200 MG/ML Prefilled Syringe",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "200 MG/ML",
      strengthValue: 200.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 1996193,
      drugName: "1.5 ML Buprenorphine 200 MG/ML Prefilled Syringe [Sublocade]",
      doseFormCode: 721656,
      doseFormName: "Prefilled Syringe",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "200 MG/ML",
      strengthValue: 200.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2003714,
      drugName: "1 ML Morphine Sulfate 2 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2045500,
      drugName:
        "Acetaminophen 300 MG / Oxycodone Hydrochloride 2.5 MG Oral Tablet [Nalocet]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2.5 MG",
      strengthValue: 2.5,
      strengthUnit: "MG",
    },
    {
      drugCode: 2055307,
      drugName: "20 ML Morphine Sulfate 10 MG/ML Injection [Mitigo]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "10 MG/ML",
      strengthValue: 10.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2055311,
      drugName: "20 ML Morphine Sulfate 25 MG/ML Injection [Mitigo]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 7052,
      ingredientName: "Morphine",
      strength: "25 MG/ML",
      strengthValue: 25.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2056893,
      drugName:
        "Chlorpheniramine Maleate 0.8 MG/ML / Codeine Phosphate 2 MG/ML / Phenylephrine Hydrochloride 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2058257,
      drugName: "Buprenorphine 16 MG / Naloxone 4 MG Sublingual Film",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2058845,
      drugName: "Levorphanol Tartrate 3 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 6378,
      ingredientName: "Levorphanol",
      strength: "3 MG",
      strengthValue: 3.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2099286,
      drugName:
        "12 HR Chlorpheniramine Maleate 8 MG / Codeine Phosphate 54.3 MG Extended Release Oral Tablet [Tuxarin]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 2670,
      ingredientName: "Codeine",
      strength: "54.3 MG",
      strengthValue: 54.3,
      strengthUnit: "MG",
    },
    {
      drugCode: 2105822,
      drugName:
        "Acetaminophen 60 MG/ML / Oxycodone Hydrochloride 2 MG/ML Oral Solution",
      doseFormCode: 316968,
      doseFormName: "Oral Solution",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "2 MG/ML",
      strengthValue: 2.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2105929,
      drugName:
        "Acetaminophen 325 MG / Caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Tablet [Dvorah]",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 23088,
      ingredientName: "dihydrocodeine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2106368,
      drugName: "Buprenorphine 16 MG / Naloxone 4 MG Sublingual Film [Cassipa]",
      doseFormCode: 2269578,
      doseFormName: "Sublingual Film",
      ingredientCode: 1819,
      ingredientName: "Buprenorphine",
      strength: "16 MG",
      strengthValue: 16.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2168270,
      drugName: "1 ML Fentanyl 0.05 MG/ML Injection",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 4337,
      ingredientName: "Fentanyl",
      strength: "0.05 MG/ML",
      strengthValue: 0.05,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2179635,
      drugName: "tramadol hydrochloride 100 MG Oral Tablet",
      doseFormCode: 317541,
      doseFormName: "Oral Tablet",
      ingredientCode: 10689,
      ingredientName: "Tramadol",
      strength: "100 MG",
      strengthValue: 100.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2183669,
      drugName:
        "Chlorpheniramine Tannate 0.8 MG/ML / hydrocodone tannate 1 MG/ML Extended Release Suspension",
      doseFormCode: 316946,
      doseFormName: "Extended Release Suspension",
      ingredientCode: 5489,
      ingredientName: "Hydrocodone",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2268081,
      drugName:
        "12 HR Naloxone Hydrochloride 10 MG / Oxycodone Hydrochloride 20 MG Extended Release Oral Tablet [Targiniq]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "20 MG",
      strengthValue: 20.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2268085,
      drugName:
        "12 HR Naloxone Hydrochloride 20 MG / Oxycodone Hydrochloride 40 MG Extended Release Oral Tablet [Targiniq]",
      doseFormCode: 316945,
      doseFormName: "Extended Release Oral Tablet",
      ingredientCode: 7804,
      ingredientName: "Oxycodone",
      strength: "40 MG",
      strengthValue: 40.0,
      strengthUnit: "MG",
    },
    {
      drugCode: 2392239,
      drugName: "1 ML Oliceridine 1 MG/ML Injection [Olinvyk]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 2392230,
      ingredientName: "Oliceridine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2392243,
      drugName: "2 ML Oliceridine 1 MG/ML Injection [Olinvyk]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 2392230,
      ingredientName: "Oliceridine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
    {
      drugCode: 2392245,
      drugName: "30 ML Oliceridine 1 MG/ML Injection [Olinvyk]",
      doseFormCode: 1649574,
      doseFormName: "Injection",
      ingredientCode: 2392230,
      ingredientName: "Oliceridine",
      strength: "1 MG/ML",
      strengthValue: 1.0,
      strengthUnit: "MG/ML",
    },
  ],
};

// Export for use in modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = OMTKData;
}
